export default "__VITE_ASSET__CvIkX0v$__"